var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import React from "react";
import { PollData_Layout_PollLayout_Type } from "./../../../ricos-schema/legacy/wix/rich_content/v1";
import { RCEHelpersPropTypes } from "../rce-helpers-context";
import { OptionPropTypes } from "./types";
class PollOptionBase extends React.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      loading: false,
      checked: this.isUserChoice()
    });
    __publicField(this, "handleRemove", (e) => {
      e.stopPropagation();
      this.props.remove();
    });
    __publicField(this, "handleVoteClick", async (e) => {
      const { validateUser, onBeforeVote, preventInteraction, preventVoting } = this.props.rce;
      const vote = this.props.poll.settings.permissions?.vote;
      const onVoteClick = onBeforeVote || validateUser;
      e.preventDefault();
      if (e.keyCode || preventInteraction || preventVoting) {
        return;
      }
      if (onVoteClick) {
        onVoteClick({ voteRole: vote }).then(this.toggleVote.bind(this), () => {
        });
      } else {
        this.toggleVote();
      }
    });
    __publicField(this, "handleTitleChange", (title) => {
      const { update, option } = this.props;
      return update({ ...option, title });
    });
    __publicField(this, "handleImageChange", (url) => {
      const { update, option } = this.props;
      const newOption = { ...option, image: { src: { url } } };
      return update(newOption);
    });
  }
  isEditAllowed() {
    return !this.props.option.count && !this.props.rce.isPreview;
  }
  isUserChoice() {
    const { poll, option } = this.props;
    return !!poll.ownVotes?.includes(option.id);
  }
  isViewMode() {
    return this.props.rce.isViewMode;
  }
  isGridLayout() {
    return this.props.layout.poll?.type === PollData_Layout_PollLayout_Type.GRID;
  }
  isListLayout() {
    return this.props.layout.poll?.type === PollData_Layout_PollLayout_Type.LIST;
  }
  isImageEnabled() {
    return this.props.layout.options?.enableImage;
  }
  async toggleVote() {
    this.setState({ loading: true });
    try {
      if (this.isUserChoice()) {
        await this.props.unvote(this.props.option.id);
        this.setState({ checked: false });
      } else {
        await this.props.vote(this.props.option.id);
        this.setState({ checked: true });
      }
    } catch (error) {
    } finally {
      this.setState({ loading: false });
    }
  }
  getVotePercentage() {
    const { option } = this.props;
    return option.rating || 0;
  }
  render() {
    if (this.isViewMode()) {
      return this.renderViewMode();
    }
    return this.renderEditMode();
  }
}
__publicField(PollOptionBase, "propTypes", {
  ...OptionPropTypes,
  ...RCEHelpersPropTypes
});
export {
  PollOptionBase
};
//# sourceMappingURL=PollOptionBase.js.map
